import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-male-tai-chi-yoga-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-male-tai-chi-yoga-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
	},
]

export default config
